<template>
  <div>
    <v-row dense>
      <v-col
        v-for="item in metricCardsPrimary"
        :key="item.key"
        cols="12"
        sm="6"
        lg="3">
        <v-card
          outlined
          class="metric-card metric-card--primary rounded-xl"
          :style="{ '--metric-accent': item.color }">
          <v-card-text class="metric-card__content">
            <div class="d-flex align-center justify-space-between mb-2">
              <div class="text-caption text--secondary font-weight-medium metric-card__label">{{ item.label }} {{ item.label === 'Total Anggaran Kumulatif' ? dpaStatus === 'murni' ? '(Murni)' : dpaStatus === 'p1' ? '(P1)' : '(Perubahan)' : '' }}</div>
              <div
                class="metric-icon-box"
                :style="{ '--metric-icon-tint': item.color }">
                <span
                  v-if="item.statEmoji"
                  class="metric-emoji"
                  aria-hidden="true">{{ item.statEmoji }}</span>
                <v-icon
                  v-else
                  size="18"
                  color="white">
                  {{ item.icon }}
                </v-icon>
              </div>
            </div>
            <div
              v-if="loadingSummaryMurni || loadingSummary"
              class="text-h6 font-weight-bold metric-value">
              <v-skeleton-loader
                type="text"
                width="100%"
                height="32px" />
            </div>
            <div v-else class="text-h6 font-weight-bold metric-value">{{ item.label === 'Total Anggaran Kumulatif' ? dpaStatus === 'murni' ? item.value : dpaStatus === 'p1' ? metricCardsSecondary.find(card => card.key === 'grand_total_anggaran_p1')?.value : metricCardsSecondary.find(card => card.key === 'grand_total_anggaran_perubahan')?.value : item.value }}</div>
            <div
              v-if="item.description"
              class="metric-sub mt-2">
              {{ item.description }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-expansion-panels
      v-if="metricCardsSecondary.length"
      class="mt-4 metric-expansion"
      flat>
      <v-expansion-panel>
        <v-expansion-panel-header class="py-3">
          <span class="text-body-2 font-weight-medium">
            Metrik tambahan ({{ metricCardsSecondary.length }})
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mx-3">
            <v-col
              v-for="item in metricCardsSecondary"
              :key="item.key"
              cols="12"
              sm="6"
              md="4">
              <v-card
                outlined
                class="metric-card rounded-xl">
                <v-card-text>
                  <div class="d-flex align-center justify-space-between mb-3">
                    <div class="text-caption text--secondary font-weight-medium">{{ item.label }}</div>
                    <v-avatar
                      size="34"
                      :color="item.color"
                      class="metric-icon">
                      <v-icon
                        size="18"
                        color="white">
                        {{ item.icon }}
                      </v-icon>
                    </v-avatar>
                  </div>
                  <div
                    v-if="loadingSummaryMurni || loadingSummary"
                    class="text-h6 font-weight-bold metric-value">
                    <v-skeleton-loader
                      type="text"
                      width="100%"
                      height="32px" />
                  </div>
                  <div v-else class="text-h6 font-weight-bold metric-value">{{ item.value }}</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels> -->
  </div>
</template>

<script>
export default {
  name: 'SimpelbangStats',
  props: {
    loadingSummaryMurni: {
      type: Boolean,
      default: false
    },
    loadingSummary: {
      type: Boolean,
      default: false
    },
    dpaStatus: {
      type: String,
      default: 'murni'
    },
    metricCardsPrimary: {
      type: Array,
      default: () => []
    },
    metricCardsSecondary: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.metric-card {
  height: 100%;
  border-radius: 22px;
  border: 1px solid rgba(21, 73, 135, 0.12) !important;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.metric-card--primary {
  background: linear-gradient(180deg, #ffffff, #f8fbff) !important;
}

.metric-card--primary::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: var(--metric-accent, #1757b8);
}

.metric-card__content {
  padding: 16px !important;
}

.metric-card__label {
  max-width: 70%;
}

.metric-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 26px rgba(40, 71, 129, 0.14) !important;
}

.metric-expansion {
  border: 1px solid #e8ecf1 !important;
  border-radius: 12px !important;
  overflow: hidden;
}

.metric-value {
  line-height: 1.2;
  word-break: break-word;
  font-size: clamp(24px, 2.7vw, 34px) !important;
  color: #16324f;
}

.metric-sub {
  font-size: 12px;
  color: #8392a5;
  line-height: 1.45;
}

.metric-icon-box {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(17, 64, 122, 0.12);
  background: var(--metric-icon-tint);
}

@supports (background: color-mix(in srgb, red, white)) {
  .metric-icon-box {
    background: color-mix(in srgb, var(--metric-icon-tint) 99%, #ffffff);
  }
}

.metric-emoji {
  font-size: 20px;
  line-height: 1;
  user-select: none;
  color: #000
}
</style>
